import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Home, ArrowLeftRight, HandCoins, PiggyBank, Wallet } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ADMIN_TABS = [
  { to: "/", label: "Beranda", Icon: Home, testId: "nav-beranda", end: true },
  { to: "/transaksi", label: "Transaksi", Icon: ArrowLeftRight, testId: "nav-transaksi" },
  { to: "/hutang", label: "Hutang", Icon: HandCoins, testId: "nav-hutang" },
  { to: "/tabungan", label: "Tabungan", Icon: PiggyBank, testId: "nav-tabungan" },
  { to: "/rekening", label: "Rekening", Icon: Wallet, testId: "nav-rekening" },
];

const MEMBER_TABS = [
  { to: "/", label: "Beranda", Icon: Home, testId: "nav-beranda", end: true },
];

export default function AppShell() {
  const { user } = useAuth();
  const isMember = user?.role === "member";
  const TABS = isMember ? MEMBER_TABS : ADMIN_TABS;

  return (
    <div
      className="max-w-[380px] w-full mx-auto min-h-screen bg-slate-50 relative flex flex-col shadow-2xl"
      style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
    >
      <main className="flex-1 overflow-y-auto pb-24" data-testid="app-main">
        <Outlet />
      </main>
      <nav
        className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[380px] bg-white border-t border-slate-200 z-40"
        data-testid="bottom-nav"
      >
        <ul
          className="grid h-16"
          style={{ gridTemplateColumns: "repeat(" + TABS.length + ", 1fr)" }}
        >
          {TABS.map(({ to, label, Icon, testId, end }) => (
            <li key={to} className="flex">
              <NavLink
                to={to}
                end={end}
                data-testid={testId}
                className={({ isActive }) =>
                  "flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold tap " +
                  (isActive ? "text-[#1F4E5F]" : "text-slate-400")
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                    <span>{label}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}